import { newrelic } from "@jti/fe-clients";
import type { ApiMagentoOrderAttributeInput, ApiMagentoPlaceOrderMutationPayload } from "@jti/magento-types";
import { useGetCustomerCartIdQuery, usePlaceOrderMutation } from "@jti/store/slices/magentoApiSlice";
import { useTranslations } from "@jti/ui";

export const PLACE_ORDER_MUTATION_CACHE_KEY = "shared-place-order-result";

export const usePlaceOrder = () => {
  const getCustomerCartIdQuery = useGetCustomerCartIdQuery();
  const { __ } = useTranslations();
  const [placeOrderMutation, placeOrderMutationResult] = usePlaceOrderMutation({
    fixedCacheKey: PLACE_ORDER_MUTATION_CACHE_KEY,
  });
  const customerCartId = getCustomerCartIdQuery.data?.customerCart.id;

  const placeOrder = async (additionalAttributes: ApiMagentoOrderAttributeInput[] = []) => {
    if (!customerCartId) {
      const error = new Error(__("cart.checkout.place_order.error.no_cart_id"));
      newrelic.noticeError(error);

      throw error;
    }

    const payload: ApiMagentoPlaceOrderMutationPayload = {
      cartId: customerCartId,
      additionalAttributes,
    };

    return await placeOrderMutation(payload).unwrap();
  };

  return {
    placeOrder,
    placeOrderResult: placeOrderMutationResult,
  };
};
